import { WebsiteId } from '#root/src/env';

export default function getLocaleKeys(): WebsiteId[] {
  return import.meta.env.VITE_LOCALE_CODE_NAME_MAP.split(';').map((el: string) => el.split(':')[0]);
}
